import SingleSliderType from './SingleSliderType';
export default SingleSliderType;
